import {
  STONE_BED_POINTS_MOVED,
  STONE_BED_SWITCH_VISIBILITY,
  STONE_BED_COMPUTE,
  STONE_BED_SET_SEPARATION_DISTANCE,
  PROJECTS_CRUD_RESTORE_STATE,
  APPTOOLBAR_RESET_APP_STATE,
  SUB_PROJECTS_CRUD_RESTORE_STATE, MULTIBED_RESET_APP_STATE, APPTOOLBAR_BASIC_RESET_APP_STATE,
} from "../lib/types";

import dataset from "../lib/datasets/dataset.json";
import CalculationsLib from "../lib/calculations";

const initialState = {
  sepDistance: 12,
  points: [],
  angles: [],
  visible: true
};

const actualInitialState = {
  ...initialState,
  manifoldStructures: dataset.manifoldStructures,
  manifoldPipeSizes: dataset.manifoldPipeSizes
};

export const StoneBedInitialState = initialState;

export default (state = actualInitialState, action) => {
  /* discriminate the action type */
  switch (action.type) {
    case STONE_BED_POINTS_MOVED:
      return {
        ...state,
        /* copy the old points array and return translated points */
        points: state.points.map((n, i) => {
          /* this is a translated coordinate(X) */
          if (action.payload[i]) {
            return action.payload[i][0];
            /* this is a translated coordinate(Y) */
          } else if (action.payload[i - 1]) {
            return action.payload[i - 1][1];
          } else {
            /* this is coordinated was not translated*/
            return n;
          }
        })
      };

    case STONE_BED_SWITCH_VISIBILITY:
      return {
        ...state,
        visible: !state.visible
      };

      case STONE_BED_COMPUTE:
      /* the computed points */
      let points = CalculationsLib.computePoints(
        state,
        action.payload.chamberRows,
        action.payload.chamberRowSpacingPixels,
        action.payload.sepDistancePixels,
        action.payload.underDrainSepDistancePixels,
        action.payload.includeUnderdrain,
        action.payload.manifoldSeparations,
        action.payload.upperManifolds,
        action.payload.lowerManifolds,
        action.payload.sepDistance,
        action.payload.chamberType,
        action.payload.chamberRowSpacing,
        action.payload.scalePixels,
        action.payload.scaleValue
      );
      /* the computed angles */
      let angles = CalculationsLib.computeAngles(
        points.slice(0, points.length - 2)
      );
      /* return the state */
      return {
        ...state,
        points: points,
        angles: angles
      };

      case STONE_BED_SET_SEPARATION_DISTANCE:
      return {
        ...state,
        sepDistance: action.payload.sepDistance,
        points: CalculationsLib.computePoints(
          state,
          action.payload.chamberRows,
          action.payload.chamberRowSpacingPixels,
          action.payload.sepDistancePixels,
          action.payload.underDrainSepDistancePixels,
          action.payload.includeUnderdrain,
          action.payload.manifoldSeparations,
          action.payload.upperManifolds,
          action.payload.lowerManifolds,
          action.payload.sepDistance,
          action.payload.chamberType,
          action.payload.chamberRowSpacing,
            action.payload.scalePixels,
            action.payload.scaleValue
        )
      };

    case APPTOOLBAR_BASIC_RESET_APP_STATE:
    case MULTIBED_RESET_APP_STATE:
    case APPTOOLBAR_RESET_APP_STATE:
      return {
        ...initialState,
        manifoldStructures: state.manifoldStructures,
        manifoldPipeSizes: state.manifoldPipeSizes
      };


    case SUB_PROJECTS_CRUD_RESTORE_STATE:
    case PROJECTS_CRUD_RESTORE_STATE:
      let rState = action.payload.stonebed;
      /* todo transformation logic here */
      return {
        ...rState,
        manifoldStructures: state.manifoldStructures,
        manifoldPipeSizes: state.manifoldPipeSizes
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/stone-bed-reducer.js